import { ImageFormat } from "@Components/weather-report/figure/Image";
import { Image } from "@MeteoApi/models/Image";
import { getMonth, getYear, isValid } from "date-fns";

export const getArticleDate = () => {
  const date = new Date(
    new URLSearchParams(window.location.hash.slice(1)).get("date") ||
      window.location.hash.slice(1),
  );
  if (isValid(date)) {
    return {
      year: getYear(date).toString(),
      // getMonth returns 0-indexed month, so we need to add 1 to get the correct month demanded by the API
      month: (getMonth(date) + 1).toString(),
      day: date.getDate().toString(),
    };
  } else {
    return "today" as const;
  }
};

export const getArticleImageUrl = (
  image: Exclude<Image, keyof Pick<Image, "id">>,
  format: ImageFormat,
  isDarkMode: boolean,
): string => {
  const { url, url_responsive, url_dark } = image;
  switch (format) {
    case "compact":
      return isDarkMode && url_dark ? url_dark : url;
    case "avatar":
      return url_responsive ?? url;
    case "avatar-small":
      return url_responsive ?? url;
    default:
      return url;
  }
};
